import { render } from "./admin_create.vue?vue&type=template&id=5d1c92c7"
import script from "./admin_create.vue?vue&type=script&lang=js"
export * from "./admin_create.vue?vue&type=script&lang=js"

import exportComponent from "E:\\work\\高大\\pps\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__